import { SeatUsageResponseSchema } from './seat-usage.schema';
/**
 * Show Tenant Seat Usage Endpoint Contract
 * Retrieves the seat caps and taken seats of a tenant (superadmin only)
 */ export const showTenantSeatUsageContract = {
    method: 'GET',
    path: '/api/v2/tenants/:tenantId/seat-usage',
    description: 'Get tenant seat limits and usage (superadmin only)',
    responseSchema: SeatUsageResponseSchema,
    statusCodes: {
        success: 200,
        errors: {
            400: 'Bad Request - invalid tenant ID format',
            401: 'Unauthorized - user not authenticated',
            403: 'Forbidden - superadmin access required',
            404: 'Tenant not found'
        }
    }
};
/**
 * Show Organization Seat Usage Endpoint Contract
 * Retrieves the seat caps and taken seats of the authenticated user's own
 * organization
 */ export const showOrganizationSeatUsageContract = {
    method: 'GET',
    path: '/api/v2/organization/seat-usage',
    description: "Get seat limits and usage for the authenticated user's tenant",
    responseSchema: SeatUsageResponseSchema,
    statusCodes: {
        success: 200,
        errors: {
            401: 'Unauthorized - user not authenticated',
            403: 'Forbidden - insufficient permissions'
        }
    }
};

//# sourceMappingURL=seat-usage.contract.js.map